import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const FIRSTNONBLANK = () => {
  return (
    <CardSection id="FIRSTNONBLANK" title="FIRSTNONBLANK">
      <Paragraph>
        두 개 이상 열의 값을 비교하여 비어 있지 않은 첫 번째 값을 반환합니다. 이
        함수는 Excel의 FIRSTNONBLANK 함수와 동일한 출력을 제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>
          FIRSTNONBLANK(ARGUMENT_1, [ARGUMENT_2, ...])
        </Paragraph>
        <Ul>
          <Li>
            <b>ARGUMENT_1</b>은 첫 번째 열입니다.
          </Li>
          <Li>
            <b>ARGUMENT_2, ... [선택사항]</b>은 추가 열입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
        {/* <Img src="computeDateFormat" /> */}
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          하나의 열만 지정한 경우 제공된 열의 값이 반환됩니다.
        </Paragraph>
        <Paragraph>
          비어 있지 않은 값이 발견되지 않으면 FIRSTNONBLANK 함수는 빈 셀을
          반환합니다(공백이 아닌 값이 발견되지 않을 때 출력에 표시할 값에 대한
          최종 인수를 포함하지 않는 한).
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
